import React from 'react'
import { Product } from 'components'
import { BasketTypes } from 'types'

import './ProductList.scss'

interface Props {
    items: BasketTypes.Item[],
    edit: boolean
}

interface State {
    total: number
}

export default class ProductList extends React.Component<Props, State> {

    static getDerivedStateFromProps ( nextProps: any ) {
        if (nextProps) {
            let calcTotal: number = 0

            nextProps.items.map((item: BasketTypes.Item ) =>
                calcTotal = calcTotal + item.quantity)

            return {
                total: calcTotal
            }
        } else {
            return null
        }
    }

    constructor(props: Props) {
        super(props)
        this.state = {
            total: 0
        }
    }

    render() {

        return (
            <div id="product-list">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Products</th>
                            <th>Week</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.props.items.length > 0 ?
                        this.props.items.map((item: BasketTypes.Item, index: number) =>
                            <Product key={index} item={item} edit={this.props.edit}/>
                        ) :
                        <tr>
                            <td colSpan={3}>No products</td>
                        </tr>
                    }
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={2}>Total</td>
                            <td>{this.state.total > 0 && this.state.total}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ProductList/index.tsx